import React, { FC, useCallback, useState } from "react"
import { CollapsibleContext } from "./components/CollapsibleContext"

export interface CollapsibleProps {
  className?: string
  isCollapsible?: boolean
  isInitiallyCollapsed?: boolean
}

export const Collapsible: FC<CollapsibleProps> = ({
  className,
  isCollapsible = false,
  isInitiallyCollapsed = false,
  children,
}) => {
  const [isCollapsed, setCollapsed] = useState(isInitiallyCollapsed)

  const handleToggleCollapsed = useCallback(() => {
    setCollapsed(prev => !prev)
  }, [])

  return (
    <CollapsibleContext.Provider
      value={{
        isCollapsed,
        isCollapsible,
        onToggleCollapsed: isCollapsible ? handleToggleCollapsed : undefined,
      }}
    >
      <div className={className}>{children}</div>
    </CollapsibleContext.Provider>
  )
}

Collapsible.defaultProps = {
  isCollapsible: false,
  isInitiallyCollapsed: false,
}
